export default __webpack_public_path__ + "assets/images/g-last-before-656e5337.png";